import {fabric} from "fabric";
import {setDeleteImage, setDeleteModal, setLoading} from "../store/reducers/modalToggler";
import {fileUploaderToServer} from "./helpers";
import {addArtImage} from "./addItems";
export function handleKeyboardShortcuts(canvas, activeSheet, dispatch)
{
	let _clipboard;
	let useFabricClipboard = false;
	const KEY_CODES = {
		B_BOLD: 66,
		I_ITALIC: 73,
		C_COPY: 67,
		V_PASTE: 86,
		U_UNDERLINE: 85,
		DELETE: 46,
		TAB: 9,
		Z_UNDO: 90,
		Y_REDO: 89,
		A_SELECT_ALL: 65,
	};

	document.addEventListener("copy", (e) => {
		const activeObject = canvas.getActiveObject();
		if (activeObject) {
			e.preventDefault();

			activeObject.clone((cloned) => {
				_clipboard = cloned;
			});

			// Add a custom MIME type to tag this as an internal copy
			try {
				e.clipboardData.setData("application/fabric-object", "fabric-copy");
			} catch (err) {
				console.warn("Custom MIME type not allowed in this browser.");
			}
		}
	});

	document.addEventListener("paste", (e) => {
		const dT = e.clipboardData || window.clipboardData;
		const files = dT.files;

		const isInternalCopy = dT.types && [...dT.types].includes("application/fabric-object");

		if (isInternalCopy && _clipboard) {
			// ✅ Paste from canvas
			_clipboard.clone((clonedObj) => {
				canvas.discardActiveObject();
				clonedObj.set({
					left: (clonedObj.left || 100) + 10,
					top: (clonedObj.top || 100) + 10,
					evented: true,
				});
				canvas.add(clonedObj);
				canvas.setActiveObject(clonedObj);
				canvas.requestRenderAll();
			});
			useFabricClipboard = false;
			return;
		}

		if (files?.length && files[0].type.includes("image")) {
			// ✅ External image paste
			const file = files[0];
			(async () => {
				dispatch(setLoading(true));
				const resImageFiles = await fileUploaderToServer([file], 1, dispatch);
				const { image: imageUrl, id } = resImageFiles[0];
				addArtImage(imageUrl, 100, 100, canvas, id, activeSheet, true).then((newImage) => {
					newImage.scaleToWidth(canvas.getWidth() / 3);
					canvas.renderAll();
					dispatch(setLoading(false));
				});
			})();
		}
	});

	document.addEventListener('keydown', (e) =>
	{
		if (e.target.tagName === 'INPUT')
		{
			return;
		}

		const activeObjects = canvas.getActiveObjects();

		// CTRL + A: Select All
		if (e.ctrlKey && e.keyCode === KEY_CODES.A_SELECT_ALL)
		{
			e.preventDefault(); // Prevent browser default behavior for Ctrl+A
			selectAllObjectsOnCanvas(canvas);
		}

		// Delete: Delete selected object or group
		if (e.keyCode === KEY_CODES.DELETE)
		{
			if(!activeObjects.length)return;
			let dataURL = canvas.getActiveObject().toDataURL({format: 'png', quality: 0.7});
			dispatch(setDeleteImage(dataURL))
			dispatch(setDeleteModal(true))
		}

		// TAB: Select the next object in the canvas
		if (e.keyCode === KEY_CODES.TAB)
		{
			e.preventDefault(); // Prevent browser default behavior for TAB key
			const objects = canvas.getObjects();
			if (objects.length > 0)
			{
				const activeObject = canvas.getActiveObject();
				let nextIndex = 0;

				if (activeObject)
				{
					const currentIndex = objects.indexOf(activeObject);
					nextIndex = (currentIndex + 1) % objects.length;
				}

				canvas.setActiveObject(objects[nextIndex]);
				canvas.renderAll();
			}
		}
	});

	function selectAllObjectsOnCanvas(canvas)
	{
		const objects = canvas.getObjects();
		if (objects.length > 0)
		{
			const activeSelection = new fabric.ActiveSelection(objects, { canvas: canvas });
			canvas.setActiveObject(activeSelection);
			canvas.renderAll();
		}
	}
}